// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".landing-subtitle[data-v-5ffaa26f] {\n  text-align: center;\n  margin: var(--size-16) 0;\n  font-size: var(--size-16);\n  line-height: var(--size-22);\n  font-weight: 400;\n}\n.landing-subtitle_uppercase[data-v-5ffaa26f] {\n  text-transform: uppercase;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
